/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TalentRouteImport } from './routes/talent'
import { Route as SponsorsRouteImport } from './routes/sponsors'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as RobotsDottxtRouteImport } from './routes/robots[.]txt'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OrganizerRouteImport } from './routes/organizer'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as FestRouteImport } from './routes/fest'
import { Route as EventsRouteImport } from './routes/events'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as CompanyRouteImport } from './routes/company'
import { Route as CollegesRouteImport } from './routes/colleges'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AmbassadorsRouteImport } from './routes/ambassadors'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as StudentRouteImport } from './routes/_student'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrganizerIndexRouteImport } from './routes/organizer.index'
import { Route as FestIndexRouteImport } from './routes/fest.index'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as CompanyIndexRouteImport } from './routes/company.index'
import { Route as CollegesIndexRouteImport } from './routes/colleges.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as SponsorScanRouteImport } from './routes/sponsor.scan'
import { Route as SponsorPricingRouteImport } from './routes/sponsor.pricing'
import { Route as SponsorDashboardRouteImport } from './routes/sponsor.dashboard'
import { Route as OrganizerWalletRouteImport } from './routes/organizer.wallet'
import { Route as OrganizerTeamRouteImport } from './routes/organizer.team'
import { Route as OrganizerSponsorAssetsRouteImport } from './routes/organizer.sponsor-assets'
import { Route as OrganizerSettingsRouteImport } from './routes/organizer.settings'
import { Route as OrganizerScanRouteImport } from './routes/organizer.scan'
import { Route as OrganizerNewRouteImport } from './routes/organizer.new'
import { Route as OrganizerMessagesRouteImport } from './routes/organizer.messages'
import { Route as OrganizerAlertsRouteImport } from './routes/organizer.alerts'
import { Route as OrganizerActivityRouteImport } from './routes/organizer.activity'
import { Route as InviteAcceptRouteImport } from './routes/invite.accept'
import { Route as FestSlugRouteImport } from './routes/fest.$slug'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as CompanyWalletRouteImport } from './routes/company.wallet'
import { Route as CompanySettingsRouteImport } from './routes/company.settings'
import { Route as CompanyScanRouteImport } from './routes/company.scan'
import { Route as CompanyProposalsRouteImport } from './routes/company.proposals'
import { Route as CompanyMessagesRouteImport } from './routes/company.messages'
import { Route as CompanyMarketplaceRouteImport } from './routes/company.marketplace'
import { Route as CompanyBrandAssetsRouteImport } from './routes/company.brand-assets'
import { Route as CompanyAlertsRouteImport } from './routes/company.alerts'
import { Route as CollegesCollegeSlugRouteImport } from './routes/colleges.$collegeSlug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminIntegrationsRouteImport } from './routes/admin.integrations'
import { Route as AdminGiftCardsRouteImport } from './routes/admin.gift-cards'
import { Route as AdminEventsRouteImport } from './routes/admin.events'
import { Route as AdminCouponsRouteImport } from './routes/admin.coupons'
import { Route as AdminCompaniesRouteImport } from './routes/admin.companies'
import { Route as AdminCollegesRouteImport } from './routes/admin.colleges'
import { Route as AdminCitiesRouteImport } from './routes/admin.cities'
import { Route as AdminBroadcastsRouteImport } from './routes/admin.broadcasts'
import { Route as AdminApprovalsRouteImport } from './routes/admin.approvals'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminAdminsRouteImport } from './routes/admin.admins'
import { Route as StudentWalletRouteImport } from './routes/_student.wallet'
import { Route as StudentTicketsRouteImport } from './routes/_student.tickets'
import { Route as StudentSocialRouteImport } from './routes/_student.social'
import { Route as StudentShopRouteImport } from './routes/_student.shop'
import { Route as StudentSettingsRouteImport } from './routes/_student.settings'
import { Route as StudentReferralsRouteImport } from './routes/_student.referrals'
import { Route as StudentOrdersRouteImport } from './routes/_student.orders'
import { Route as StudentMemoriesRouteImport } from './routes/_student.memories'
import { Route as StudentDashboardRouteImport } from './routes/_student.dashboard'
import { Route as StudentCommitteesRouteImport } from './routes/_student.committees'
import { Route as StudentCertificationsRouteImport } from './routes/_student.certifications'
import { Route as StudentAlertsRouteImport } from './routes/_student.alerts'
import { Route as StudentActivityRouteImport } from './routes/_student.activity'
import { Route as OrganizerEventsIndexRouteImport } from './routes/organizer.events.index'
import { Route as OrganizerEventsEventIdRouteImport } from './routes/organizer.events.$eventId'
import { Route as StudentExploreEventIdRouteImport } from './routes/_student.explore.$eventId'
import { Route as OrganizerEventsEventIdEditRouteImport } from './routes/organizer.events.$eventId.edit'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TalentRoute = TalentRouteImport.update({
  id: '/talent',
  path: '/talent',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsorsRoute = SponsorsRouteImport.update({
  id: '/sponsors',
  path: '/sponsors',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const RobotsDottxtRoute = RobotsDottxtRouteImport.update({
  id: '/robots.txt',
  path: '/robots.txt',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundRoute = RefundRouteImport.update({
  id: '/refund',
  path: '/refund',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizerRoute = OrganizerRouteImport.update({
  id: '/organizer',
  path: '/organizer',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const FestRoute = FestRouteImport.update({
  id: '/fest',
  path: '/fest',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRoute = CompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const CollegesRoute = CollegesRouteImport.update({
  id: '/colleges',
  path: '/colleges',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AmbassadorsRoute = AmbassadorsRouteImport.update({
  id: '/ambassadors',
  path: '/ambassadors',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentRoute = StudentRouteImport.update({
  id: '/_student',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizerIndexRoute = OrganizerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizerRoute,
} as any)
const FestIndexRoute = FestIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FestRoute,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EventsRoute,
} as any)
const CompanyIndexRoute = CompanyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompanyRoute,
} as any)
const CollegesIndexRoute = CollegesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CollegesRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SponsorScanRoute = SponsorScanRouteImport.update({
  id: '/sponsor/scan',
  path: '/sponsor/scan',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsorPricingRoute = SponsorPricingRouteImport.update({
  id: '/sponsor/pricing',
  path: '/sponsor/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsorDashboardRoute = SponsorDashboardRouteImport.update({
  id: '/sponsor/dashboard',
  path: '/sponsor/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizerWalletRoute = OrganizerWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerTeamRoute = OrganizerTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerSponsorAssetsRoute = OrganizerSponsorAssetsRouteImport.update({
  id: '/sponsor-assets',
  path: '/sponsor-assets',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerSettingsRoute = OrganizerSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerScanRoute = OrganizerScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerNewRoute = OrganizerNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerMessagesRoute = OrganizerMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerAlertsRoute = OrganizerAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerActivityRoute = OrganizerActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => OrganizerRoute,
} as any)
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/accept',
  path: '/accept',
  getParentRoute: () => InviteRoute,
} as any)
const FestSlugRoute = FestSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => FestRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => EventsRoute,
} as any)
const CompanyWalletRoute = CompanyWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanySettingsRoute = CompanySettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyScanRoute = CompanyScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyProposalsRoute = CompanyProposalsRouteImport.update({
  id: '/proposals',
  path: '/proposals',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyMessagesRoute = CompanyMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyMarketplaceRoute = CompanyMarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyBrandAssetsRoute = CompanyBrandAssetsRouteImport.update({
  id: '/brand-assets',
  path: '/brand-assets',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyAlertsRoute = CompanyAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => CompanyRoute,
} as any)
const CollegesCollegeSlugRoute = CollegesCollegeSlugRouteImport.update({
  id: '/$collegeSlug',
  path: '/$collegeSlug',
  getParentRoute: () => CollegesRoute,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGiftCardsRoute = AdminGiftCardsRouteImport.update({
  id: '/gift-cards',
  path: '/gift-cards',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventsRoute = AdminEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCouponsRoute = AdminCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCollegesRoute = AdminCollegesRouteImport.update({
  id: '/colleges',
  path: '/colleges',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCitiesRoute = AdminCitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBroadcastsRoute = AdminBroadcastsRouteImport.update({
  id: '/broadcasts',
  path: '/broadcasts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApprovalsRoute = AdminApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminsRoute = AdminAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AdminRoute,
} as any)
const StudentWalletRoute = StudentWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => StudentRoute,
} as any)
const StudentTicketsRoute = StudentTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => StudentRoute,
} as any)
const StudentSocialRoute = StudentSocialRouteImport.update({
  id: '/social',
  path: '/social',
  getParentRoute: () => StudentRoute,
} as any)
const StudentShopRoute = StudentShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => StudentRoute,
} as any)
const StudentSettingsRoute = StudentSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StudentRoute,
} as any)
const StudentReferralsRoute = StudentReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => StudentRoute,
} as any)
const StudentOrdersRoute = StudentOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => StudentRoute,
} as any)
const StudentMemoriesRoute = StudentMemoriesRouteImport.update({
  id: '/memories',
  path: '/memories',
  getParentRoute: () => StudentRoute,
} as any)
const StudentDashboardRoute = StudentDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => StudentRoute,
} as any)
const StudentCommitteesRoute = StudentCommitteesRouteImport.update({
  id: '/committees',
  path: '/committees',
  getParentRoute: () => StudentRoute,
} as any)
const StudentCertificationsRoute = StudentCertificationsRouteImport.update({
  id: '/certifications',
  path: '/certifications',
  getParentRoute: () => StudentRoute,
} as any)
const StudentAlertsRoute = StudentAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StudentRoute,
} as any)
const StudentActivityRoute = StudentActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => StudentRoute,
} as any)
const OrganizerEventsIndexRoute = OrganizerEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => OrganizerRoute,
} as any)
const OrganizerEventsEventIdRoute = OrganizerEventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => OrganizerRoute,
} as any)
const StudentExploreEventIdRoute = StudentExploreEventIdRouteImport.update({
  id: '/explore/$eventId',
  path: '/explore/$eventId',
  getParentRoute: () => StudentRoute,
} as any)
const OrganizerEventsEventIdEditRoute =
  OrganizerEventsEventIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => OrganizerEventsEventIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/ambassadors': typeof AmbassadorsRoute
  '/blog': typeof BlogRouteWithChildren
  '/colleges': typeof CollegesRouteWithChildren
  '/company': typeof CompanyRouteWithChildren
  '/cookie-policy': typeof CookiePolicyRoute
  '/events': typeof EventsRouteWithChildren
  '/fest': typeof FestRouteWithChildren
  '/invite': typeof InviteRouteWithChildren
  '/login': typeof LoginRoute
  '/organizer': typeof OrganizerRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/signup': typeof SignupRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/sponsors': typeof SponsorsRoute
  '/talent': typeof TalentRoute
  '/terms': typeof TermsRoute
  '/activity': typeof StudentActivityRoute
  '/alerts': typeof StudentAlertsRoute
  '/certifications': typeof StudentCertificationsRoute
  '/committees': typeof StudentCommitteesRoute
  '/dashboard': typeof StudentDashboardRoute
  '/memories': typeof StudentMemoriesRoute
  '/orders': typeof StudentOrdersRoute
  '/referrals': typeof StudentReferralsRoute
  '/settings': typeof StudentSettingsRoute
  '/shop': typeof StudentShopRoute
  '/social': typeof StudentSocialRoute
  '/tickets': typeof StudentTicketsRoute
  '/wallet': typeof StudentWalletRoute
  '/admin/admins': typeof AdminAdminsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/cities': typeof AdminCitiesRoute
  '/admin/colleges': typeof AdminCollegesRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/gift-cards': typeof AdminGiftCardsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/colleges/$collegeSlug': typeof CollegesCollegeSlugRoute
  '/company/alerts': typeof CompanyAlertsRoute
  '/company/brand-assets': typeof CompanyBrandAssetsRoute
  '/company/marketplace': typeof CompanyMarketplaceRoute
  '/company/messages': typeof CompanyMessagesRoute
  '/company/proposals': typeof CompanyProposalsRoute
  '/company/scan': typeof CompanyScanRoute
  '/company/settings': typeof CompanySettingsRoute
  '/company/wallet': typeof CompanyWalletRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/fest/$slug': typeof FestSlugRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/organizer/activity': typeof OrganizerActivityRoute
  '/organizer/alerts': typeof OrganizerAlertsRoute
  '/organizer/messages': typeof OrganizerMessagesRoute
  '/organizer/new': typeof OrganizerNewRoute
  '/organizer/scan': typeof OrganizerScanRoute
  '/organizer/settings': typeof OrganizerSettingsRoute
  '/organizer/sponsor-assets': typeof OrganizerSponsorAssetsRoute
  '/organizer/team': typeof OrganizerTeamRoute
  '/organizer/wallet': typeof OrganizerWalletRoute
  '/sponsor/dashboard': typeof SponsorDashboardRoute
  '/sponsor/pricing': typeof SponsorPricingRoute
  '/sponsor/scan': typeof SponsorScanRoute
  '/admin/': typeof AdminIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/colleges/': typeof CollegesIndexRoute
  '/company/': typeof CompanyIndexRoute
  '/events/': typeof EventsIndexRoute
  '/fest/': typeof FestIndexRoute
  '/organizer/': typeof OrganizerIndexRoute
  '/explore/$eventId': typeof StudentExploreEventIdRoute
  '/organizer/events/$eventId': typeof OrganizerEventsEventIdRouteWithChildren
  '/organizer/events/': typeof OrganizerEventsIndexRoute
  '/organizer/events/$eventId/edit': typeof OrganizerEventsEventIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ambassadors': typeof AmbassadorsRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/invite': typeof InviteRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/signup': typeof SignupRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/sponsors': typeof SponsorsRoute
  '/talent': typeof TalentRoute
  '/terms': typeof TermsRoute
  '/activity': typeof StudentActivityRoute
  '/alerts': typeof StudentAlertsRoute
  '/certifications': typeof StudentCertificationsRoute
  '/committees': typeof StudentCommitteesRoute
  '/dashboard': typeof StudentDashboardRoute
  '/memories': typeof StudentMemoriesRoute
  '/orders': typeof StudentOrdersRoute
  '/referrals': typeof StudentReferralsRoute
  '/settings': typeof StudentSettingsRoute
  '/shop': typeof StudentShopRoute
  '/social': typeof StudentSocialRoute
  '/tickets': typeof StudentTicketsRoute
  '/wallet': typeof StudentWalletRoute
  '/admin/admins': typeof AdminAdminsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/cities': typeof AdminCitiesRoute
  '/admin/colleges': typeof AdminCollegesRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/gift-cards': typeof AdminGiftCardsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/colleges/$collegeSlug': typeof CollegesCollegeSlugRoute
  '/company/alerts': typeof CompanyAlertsRoute
  '/company/brand-assets': typeof CompanyBrandAssetsRoute
  '/company/marketplace': typeof CompanyMarketplaceRoute
  '/company/messages': typeof CompanyMessagesRoute
  '/company/proposals': typeof CompanyProposalsRoute
  '/company/scan': typeof CompanyScanRoute
  '/company/settings': typeof CompanySettingsRoute
  '/company/wallet': typeof CompanyWalletRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/fest/$slug': typeof FestSlugRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/organizer/activity': typeof OrganizerActivityRoute
  '/organizer/alerts': typeof OrganizerAlertsRoute
  '/organizer/messages': typeof OrganizerMessagesRoute
  '/organizer/new': typeof OrganizerNewRoute
  '/organizer/scan': typeof OrganizerScanRoute
  '/organizer/settings': typeof OrganizerSettingsRoute
  '/organizer/sponsor-assets': typeof OrganizerSponsorAssetsRoute
  '/organizer/team': typeof OrganizerTeamRoute
  '/organizer/wallet': typeof OrganizerWalletRoute
  '/sponsor/dashboard': typeof SponsorDashboardRoute
  '/sponsor/pricing': typeof SponsorPricingRoute
  '/sponsor/scan': typeof SponsorScanRoute
  '/admin': typeof AdminIndexRoute
  '/blog': typeof BlogIndexRoute
  '/colleges': typeof CollegesIndexRoute
  '/company': typeof CompanyIndexRoute
  '/events': typeof EventsIndexRoute
  '/fest': typeof FestIndexRoute
  '/organizer': typeof OrganizerIndexRoute
  '/explore/$eventId': typeof StudentExploreEventIdRoute
  '/organizer/events/$eventId': typeof OrganizerEventsEventIdRouteWithChildren
  '/organizer/events': typeof OrganizerEventsIndexRoute
  '/organizer/events/$eventId/edit': typeof OrganizerEventsEventIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_student': typeof StudentRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/ambassadors': typeof AmbassadorsRoute
  '/blog': typeof BlogRouteWithChildren
  '/colleges': typeof CollegesRouteWithChildren
  '/company': typeof CompanyRouteWithChildren
  '/cookie-policy': typeof CookiePolicyRoute
  '/events': typeof EventsRouteWithChildren
  '/fest': typeof FestRouteWithChildren
  '/invite': typeof InviteRouteWithChildren
  '/login': typeof LoginRoute
  '/organizer': typeof OrganizerRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/signup': typeof SignupRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/sponsors': typeof SponsorsRoute
  '/talent': typeof TalentRoute
  '/terms': typeof TermsRoute
  '/_student/activity': typeof StudentActivityRoute
  '/_student/alerts': typeof StudentAlertsRoute
  '/_student/certifications': typeof StudentCertificationsRoute
  '/_student/committees': typeof StudentCommitteesRoute
  '/_student/dashboard': typeof StudentDashboardRoute
  '/_student/memories': typeof StudentMemoriesRoute
  '/_student/orders': typeof StudentOrdersRoute
  '/_student/referrals': typeof StudentReferralsRoute
  '/_student/settings': typeof StudentSettingsRoute
  '/_student/shop': typeof StudentShopRoute
  '/_student/social': typeof StudentSocialRoute
  '/_student/tickets': typeof StudentTicketsRoute
  '/_student/wallet': typeof StudentWalletRoute
  '/admin/admins': typeof AdminAdminsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/cities': typeof AdminCitiesRoute
  '/admin/colleges': typeof AdminCollegesRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/gift-cards': typeof AdminGiftCardsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/colleges/$collegeSlug': typeof CollegesCollegeSlugRoute
  '/company/alerts': typeof CompanyAlertsRoute
  '/company/brand-assets': typeof CompanyBrandAssetsRoute
  '/company/marketplace': typeof CompanyMarketplaceRoute
  '/company/messages': typeof CompanyMessagesRoute
  '/company/proposals': typeof CompanyProposalsRoute
  '/company/scan': typeof CompanyScanRoute
  '/company/settings': typeof CompanySettingsRoute
  '/company/wallet': typeof CompanyWalletRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/fest/$slug': typeof FestSlugRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/organizer/activity': typeof OrganizerActivityRoute
  '/organizer/alerts': typeof OrganizerAlertsRoute
  '/organizer/messages': typeof OrganizerMessagesRoute
  '/organizer/new': typeof OrganizerNewRoute
  '/organizer/scan': typeof OrganizerScanRoute
  '/organizer/settings': typeof OrganizerSettingsRoute
  '/organizer/sponsor-assets': typeof OrganizerSponsorAssetsRoute
  '/organizer/team': typeof OrganizerTeamRoute
  '/organizer/wallet': typeof OrganizerWalletRoute
  '/sponsor/dashboard': typeof SponsorDashboardRoute
  '/sponsor/pricing': typeof SponsorPricingRoute
  '/sponsor/scan': typeof SponsorScanRoute
  '/admin/': typeof AdminIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/colleges/': typeof CollegesIndexRoute
  '/company/': typeof CompanyIndexRoute
  '/events/': typeof EventsIndexRoute
  '/fest/': typeof FestIndexRoute
  '/organizer/': typeof OrganizerIndexRoute
  '/_student/explore/$eventId': typeof StudentExploreEventIdRoute
  '/organizer/events/$eventId': typeof OrganizerEventsEventIdRouteWithChildren
  '/organizer/events/': typeof OrganizerEventsIndexRoute
  '/organizer/events/$eventId/edit': typeof OrganizerEventsEventIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/ambassadors'
    | '/blog'
    | '/colleges'
    | '/company'
    | '/cookie-policy'
    | '/events'
    | '/fest'
    | '/invite'
    | '/login'
    | '/organizer'
    | '/privacy'
    | '/refund'
    | '/reset-password'
    | '/robots.txt'
    | '/signup'
    | '/sitemap.xml'
    | '/sponsors'
    | '/talent'
    | '/terms'
    | '/activity'
    | '/alerts'
    | '/certifications'
    | '/committees'
    | '/dashboard'
    | '/memories'
    | '/orders'
    | '/referrals'
    | '/settings'
    | '/shop'
    | '/social'
    | '/tickets'
    | '/wallet'
    | '/admin/admins'
    | '/admin/analytics'
    | '/admin/approvals'
    | '/admin/broadcasts'
    | '/admin/cities'
    | '/admin/colleges'
    | '/admin/companies'
    | '/admin/coupons'
    | '/admin/events'
    | '/admin/gift-cards'
    | '/admin/integrations'
    | '/admin/users'
    | '/blog/$slug'
    | '/colleges/$collegeSlug'
    | '/company/alerts'
    | '/company/brand-assets'
    | '/company/marketplace'
    | '/company/messages'
    | '/company/proposals'
    | '/company/scan'
    | '/company/settings'
    | '/company/wallet'
    | '/events/$eventId'
    | '/fest/$slug'
    | '/invite/accept'
    | '/organizer/activity'
    | '/organizer/alerts'
    | '/organizer/messages'
    | '/organizer/new'
    | '/organizer/scan'
    | '/organizer/settings'
    | '/organizer/sponsor-assets'
    | '/organizer/team'
    | '/organizer/wallet'
    | '/sponsor/dashboard'
    | '/sponsor/pricing'
    | '/sponsor/scan'
    | '/admin/'
    | '/blog/'
    | '/colleges/'
    | '/company/'
    | '/events/'
    | '/fest/'
    | '/organizer/'
    | '/explore/$eventId'
    | '/organizer/events/$eventId'
    | '/organizer/events/'
    | '/organizer/events/$eventId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ambassadors'
    | '/cookie-policy'
    | '/invite'
    | '/login'
    | '/privacy'
    | '/refund'
    | '/reset-password'
    | '/robots.txt'
    | '/signup'
    | '/sitemap.xml'
    | '/sponsors'
    | '/talent'
    | '/terms'
    | '/activity'
    | '/alerts'
    | '/certifications'
    | '/committees'
    | '/dashboard'
    | '/memories'
    | '/orders'
    | '/referrals'
    | '/settings'
    | '/shop'
    | '/social'
    | '/tickets'
    | '/wallet'
    | '/admin/admins'
    | '/admin/analytics'
    | '/admin/approvals'
    | '/admin/broadcasts'
    | '/admin/cities'
    | '/admin/colleges'
    | '/admin/companies'
    | '/admin/coupons'
    | '/admin/events'
    | '/admin/gift-cards'
    | '/admin/integrations'
    | '/admin/users'
    | '/blog/$slug'
    | '/colleges/$collegeSlug'
    | '/company/alerts'
    | '/company/brand-assets'
    | '/company/marketplace'
    | '/company/messages'
    | '/company/proposals'
    | '/company/scan'
    | '/company/settings'
    | '/company/wallet'
    | '/events/$eventId'
    | '/fest/$slug'
    | '/invite/accept'
    | '/organizer/activity'
    | '/organizer/alerts'
    | '/organizer/messages'
    | '/organizer/new'
    | '/organizer/scan'
    | '/organizer/settings'
    | '/organizer/sponsor-assets'
    | '/organizer/team'
    | '/organizer/wallet'
    | '/sponsor/dashboard'
    | '/sponsor/pricing'
    | '/sponsor/scan'
    | '/admin'
    | '/blog'
    | '/colleges'
    | '/company'
    | '/events'
    | '/fest'
    | '/organizer'
    | '/explore/$eventId'
    | '/organizer/events/$eventId'
    | '/organizer/events'
    | '/organizer/events/$eventId/edit'
  id:
    | '__root__'
    | '/'
    | '/_student'
    | '/admin'
    | '/ambassadors'
    | '/blog'
    | '/colleges'
    | '/company'
    | '/cookie-policy'
    | '/events'
    | '/fest'
    | '/invite'
    | '/login'
    | '/organizer'
    | '/privacy'
    | '/refund'
    | '/reset-password'
    | '/robots.txt'
    | '/signup'
    | '/sitemap.xml'
    | '/sponsors'
    | '/talent'
    | '/terms'
    | '/_student/activity'
    | '/_student/alerts'
    | '/_student/certifications'
    | '/_student/committees'
    | '/_student/dashboard'
    | '/_student/memories'
    | '/_student/orders'
    | '/_student/referrals'
    | '/_student/settings'
    | '/_student/shop'
    | '/_student/social'
    | '/_student/tickets'
    | '/_student/wallet'
    | '/admin/admins'
    | '/admin/analytics'
    | '/admin/approvals'
    | '/admin/broadcasts'
    | '/admin/cities'
    | '/admin/colleges'
    | '/admin/companies'
    | '/admin/coupons'
    | '/admin/events'
    | '/admin/gift-cards'
    | '/admin/integrations'
    | '/admin/users'
    | '/blog/$slug'
    | '/colleges/$collegeSlug'
    | '/company/alerts'
    | '/company/brand-assets'
    | '/company/marketplace'
    | '/company/messages'
    | '/company/proposals'
    | '/company/scan'
    | '/company/settings'
    | '/company/wallet'
    | '/events/$eventId'
    | '/fest/$slug'
    | '/invite/accept'
    | '/organizer/activity'
    | '/organizer/alerts'
    | '/organizer/messages'
    | '/organizer/new'
    | '/organizer/scan'
    | '/organizer/settings'
    | '/organizer/sponsor-assets'
    | '/organizer/team'
    | '/organizer/wallet'
    | '/sponsor/dashboard'
    | '/sponsor/pricing'
    | '/sponsor/scan'
    | '/admin/'
    | '/blog/'
    | '/colleges/'
    | '/company/'
    | '/events/'
    | '/fest/'
    | '/organizer/'
    | '/_student/explore/$eventId'
    | '/organizer/events/$eventId'
    | '/organizer/events/'
    | '/organizer/events/$eventId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  StudentRoute: typeof StudentRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AmbassadorsRoute: typeof AmbassadorsRoute
  BlogRoute: typeof BlogRouteWithChildren
  CollegesRoute: typeof CollegesRouteWithChildren
  CompanyRoute: typeof CompanyRouteWithChildren
  CookiePolicyRoute: typeof CookiePolicyRoute
  EventsRoute: typeof EventsRouteWithChildren
  FestRoute: typeof FestRouteWithChildren
  InviteRoute: typeof InviteRouteWithChildren
  LoginRoute: typeof LoginRoute
  OrganizerRoute: typeof OrganizerRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  RefundRoute: typeof RefundRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RobotsDottxtRoute: typeof RobotsDottxtRoute
  SignupRoute: typeof SignupRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  SponsorsRoute: typeof SponsorsRoute
  TalentRoute: typeof TalentRoute
  TermsRoute: typeof TermsRoute
  SponsorDashboardRoute: typeof SponsorDashboardRoute
  SponsorPricingRoute: typeof SponsorPricingRoute
  SponsorScanRoute: typeof SponsorScanRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/talent': {
      id: '/talent'
      path: '/talent'
      fullPath: '/talent'
      preLoaderRoute: typeof TalentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsors': {
      id: '/sponsors'
      path: '/sponsors'
      fullPath: '/sponsors'
      preLoaderRoute: typeof SponsorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/robots.txt': {
      id: '/robots.txt'
      path: '/robots.txt'
      fullPath: '/robots.txt'
      preLoaderRoute: typeof RobotsDottxtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund': {
      id: '/refund'
      path: '/refund'
      fullPath: '/refund'
      preLoaderRoute: typeof RefundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizer': {
      id: '/organizer'
      path: '/organizer'
      fullPath: '/organizer'
      preLoaderRoute: typeof OrganizerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fest': {
      id: '/fest'
      path: '/fest'
      fullPath: '/fest'
      preLoaderRoute: typeof FestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company': {
      id: '/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/colleges': {
      id: '/colleges'
      path: '/colleges'
      fullPath: '/colleges'
      preLoaderRoute: typeof CollegesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ambassadors': {
      id: '/ambassadors'
      path: '/ambassadors'
      fullPath: '/ambassadors'
      preLoaderRoute: typeof AmbassadorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_student': {
      id: '/_student'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StudentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizer/': {
      id: '/organizer/'
      path: '/'
      fullPath: '/organizer/'
      preLoaderRoute: typeof OrganizerIndexRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/fest/': {
      id: '/fest/'
      path: '/'
      fullPath: '/fest/'
      preLoaderRoute: typeof FestIndexRouteImport
      parentRoute: typeof FestRoute
    }
    '/events/': {
      id: '/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof EventsRoute
    }
    '/company/': {
      id: '/company/'
      path: '/'
      fullPath: '/company/'
      preLoaderRoute: typeof CompanyIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/colleges/': {
      id: '/colleges/'
      path: '/'
      fullPath: '/colleges/'
      preLoaderRoute: typeof CollegesIndexRouteImport
      parentRoute: typeof CollegesRoute
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/sponsor/scan': {
      id: '/sponsor/scan'
      path: '/sponsor/scan'
      fullPath: '/sponsor/scan'
      preLoaderRoute: typeof SponsorScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsor/pricing': {
      id: '/sponsor/pricing'
      path: '/sponsor/pricing'
      fullPath: '/sponsor/pricing'
      preLoaderRoute: typeof SponsorPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsor/dashboard': {
      id: '/sponsor/dashboard'
      path: '/sponsor/dashboard'
      fullPath: '/sponsor/dashboard'
      preLoaderRoute: typeof SponsorDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizer/wallet': {
      id: '/organizer/wallet'
      path: '/wallet'
      fullPath: '/organizer/wallet'
      preLoaderRoute: typeof OrganizerWalletRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/team': {
      id: '/organizer/team'
      path: '/team'
      fullPath: '/organizer/team'
      preLoaderRoute: typeof OrganizerTeamRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/sponsor-assets': {
      id: '/organizer/sponsor-assets'
      path: '/sponsor-assets'
      fullPath: '/organizer/sponsor-assets'
      preLoaderRoute: typeof OrganizerSponsorAssetsRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/settings': {
      id: '/organizer/settings'
      path: '/settings'
      fullPath: '/organizer/settings'
      preLoaderRoute: typeof OrganizerSettingsRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/scan': {
      id: '/organizer/scan'
      path: '/scan'
      fullPath: '/organizer/scan'
      preLoaderRoute: typeof OrganizerScanRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/new': {
      id: '/organizer/new'
      path: '/new'
      fullPath: '/organizer/new'
      preLoaderRoute: typeof OrganizerNewRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/messages': {
      id: '/organizer/messages'
      path: '/messages'
      fullPath: '/organizer/messages'
      preLoaderRoute: typeof OrganizerMessagesRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/alerts': {
      id: '/organizer/alerts'
      path: '/alerts'
      fullPath: '/organizer/alerts'
      preLoaderRoute: typeof OrganizerAlertsRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/activity': {
      id: '/organizer/activity'
      path: '/activity'
      fullPath: '/organizer/activity'
      preLoaderRoute: typeof OrganizerActivityRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/invite/accept': {
      id: '/invite/accept'
      path: '/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof InviteAcceptRouteImport
      parentRoute: typeof InviteRoute
    }
    '/fest/$slug': {
      id: '/fest/$slug'
      path: '/$slug'
      fullPath: '/fest/$slug'
      preLoaderRoute: typeof FestSlugRouteImport
      parentRoute: typeof FestRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof EventsRoute
    }
    '/company/wallet': {
      id: '/company/wallet'
      path: '/wallet'
      fullPath: '/company/wallet'
      preLoaderRoute: typeof CompanyWalletRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/settings': {
      id: '/company/settings'
      path: '/settings'
      fullPath: '/company/settings'
      preLoaderRoute: typeof CompanySettingsRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/scan': {
      id: '/company/scan'
      path: '/scan'
      fullPath: '/company/scan'
      preLoaderRoute: typeof CompanyScanRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/proposals': {
      id: '/company/proposals'
      path: '/proposals'
      fullPath: '/company/proposals'
      preLoaderRoute: typeof CompanyProposalsRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/messages': {
      id: '/company/messages'
      path: '/messages'
      fullPath: '/company/messages'
      preLoaderRoute: typeof CompanyMessagesRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/marketplace': {
      id: '/company/marketplace'
      path: '/marketplace'
      fullPath: '/company/marketplace'
      preLoaderRoute: typeof CompanyMarketplaceRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/brand-assets': {
      id: '/company/brand-assets'
      path: '/brand-assets'
      fullPath: '/company/brand-assets'
      preLoaderRoute: typeof CompanyBrandAssetsRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/alerts': {
      id: '/company/alerts'
      path: '/alerts'
      fullPath: '/company/alerts'
      preLoaderRoute: typeof CompanyAlertsRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/colleges/$collegeSlug': {
      id: '/colleges/$collegeSlug'
      path: '/$collegeSlug'
      fullPath: '/colleges/$collegeSlug'
      preLoaderRoute: typeof CollegesCollegeSlugRouteImport
      parentRoute: typeof CollegesRoute
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof BlogRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/integrations': {
      id: '/admin/integrations'
      path: '/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/gift-cards': {
      id: '/admin/gift-cards'
      path: '/gift-cards'
      fullPath: '/admin/gift-cards'
      preLoaderRoute: typeof AdminGiftCardsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/events': {
      id: '/admin/events'
      path: '/events'
      fullPath: '/admin/events'
      preLoaderRoute: typeof AdminEventsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/coupons': {
      id: '/admin/coupons'
      path: '/coupons'
      fullPath: '/admin/coupons'
      preLoaderRoute: typeof AdminCouponsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/colleges': {
      id: '/admin/colleges'
      path: '/colleges'
      fullPath: '/admin/colleges'
      preLoaderRoute: typeof AdminCollegesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cities': {
      id: '/admin/cities'
      path: '/cities'
      fullPath: '/admin/cities'
      preLoaderRoute: typeof AdminCitiesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/broadcasts': {
      id: '/admin/broadcasts'
      path: '/broadcasts'
      fullPath: '/admin/broadcasts'
      preLoaderRoute: typeof AdminBroadcastsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/approvals': {
      id: '/admin/approvals'
      path: '/approvals'
      fullPath: '/admin/approvals'
      preLoaderRoute: typeof AdminApprovalsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/admins': {
      id: '/admin/admins'
      path: '/admins'
      fullPath: '/admin/admins'
      preLoaderRoute: typeof AdminAdminsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_student/wallet': {
      id: '/_student/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof StudentWalletRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/tickets': {
      id: '/_student/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof StudentTicketsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/social': {
      id: '/_student/social'
      path: '/social'
      fullPath: '/social'
      preLoaderRoute: typeof StudentSocialRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/shop': {
      id: '/_student/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof StudentShopRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/settings': {
      id: '/_student/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof StudentSettingsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/referrals': {
      id: '/_student/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof StudentReferralsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/orders': {
      id: '/_student/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof StudentOrdersRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/memories': {
      id: '/_student/memories'
      path: '/memories'
      fullPath: '/memories'
      preLoaderRoute: typeof StudentMemoriesRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/dashboard': {
      id: '/_student/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof StudentDashboardRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/committees': {
      id: '/_student/committees'
      path: '/committees'
      fullPath: '/committees'
      preLoaderRoute: typeof StudentCommitteesRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/certifications': {
      id: '/_student/certifications'
      path: '/certifications'
      fullPath: '/certifications'
      preLoaderRoute: typeof StudentCertificationsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/alerts': {
      id: '/_student/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof StudentAlertsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/activity': {
      id: '/_student/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof StudentActivityRouteImport
      parentRoute: typeof StudentRoute
    }
    '/organizer/events/': {
      id: '/organizer/events/'
      path: '/events'
      fullPath: '/organizer/events/'
      preLoaderRoute: typeof OrganizerEventsIndexRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/organizer/events/$eventId': {
      id: '/organizer/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/organizer/events/$eventId'
      preLoaderRoute: typeof OrganizerEventsEventIdRouteImport
      parentRoute: typeof OrganizerRoute
    }
    '/_student/explore/$eventId': {
      id: '/_student/explore/$eventId'
      path: '/explore/$eventId'
      fullPath: '/explore/$eventId'
      preLoaderRoute: typeof StudentExploreEventIdRouteImport
      parentRoute: typeof StudentRoute
    }
    '/organizer/events/$eventId/edit': {
      id: '/organizer/events/$eventId/edit'
      path: '/edit'
      fullPath: '/organizer/events/$eventId/edit'
      preLoaderRoute: typeof OrganizerEventsEventIdEditRouteImport
      parentRoute: typeof OrganizerEventsEventIdRoute
    }
  }
}

interface StudentRouteChildren {
  StudentActivityRoute: typeof StudentActivityRoute
  StudentAlertsRoute: typeof StudentAlertsRoute
  StudentCertificationsRoute: typeof StudentCertificationsRoute
  StudentCommitteesRoute: typeof StudentCommitteesRoute
  StudentDashboardRoute: typeof StudentDashboardRoute
  StudentMemoriesRoute: typeof StudentMemoriesRoute
  StudentOrdersRoute: typeof StudentOrdersRoute
  StudentReferralsRoute: typeof StudentReferralsRoute
  StudentSettingsRoute: typeof StudentSettingsRoute
  StudentShopRoute: typeof StudentShopRoute
  StudentSocialRoute: typeof StudentSocialRoute
  StudentTicketsRoute: typeof StudentTicketsRoute
  StudentWalletRoute: typeof StudentWalletRoute
  StudentExploreEventIdRoute: typeof StudentExploreEventIdRoute
}

const StudentRouteChildren: StudentRouteChildren = {
  StudentActivityRoute: StudentActivityRoute,
  StudentAlertsRoute: StudentAlertsRoute,
  StudentCertificationsRoute: StudentCertificationsRoute,
  StudentCommitteesRoute: StudentCommitteesRoute,
  StudentDashboardRoute: StudentDashboardRoute,
  StudentMemoriesRoute: StudentMemoriesRoute,
  StudentOrdersRoute: StudentOrdersRoute,
  StudentReferralsRoute: StudentReferralsRoute,
  StudentSettingsRoute: StudentSettingsRoute,
  StudentShopRoute: StudentShopRoute,
  StudentSocialRoute: StudentSocialRoute,
  StudentTicketsRoute: StudentTicketsRoute,
  StudentWalletRoute: StudentWalletRoute,
  StudentExploreEventIdRoute: StudentExploreEventIdRoute,
}

const StudentRouteWithChildren =
  StudentRoute._addFileChildren(StudentRouteChildren)

interface AdminRouteChildren {
  AdminAdminsRoute: typeof AdminAdminsRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminApprovalsRoute: typeof AdminApprovalsRoute
  AdminBroadcastsRoute: typeof AdminBroadcastsRoute
  AdminCitiesRoute: typeof AdminCitiesRoute
  AdminCollegesRoute: typeof AdminCollegesRoute
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminCouponsRoute: typeof AdminCouponsRoute
  AdminEventsRoute: typeof AdminEventsRoute
  AdminGiftCardsRoute: typeof AdminGiftCardsRoute
  AdminIntegrationsRoute: typeof AdminIntegrationsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminsRoute: AdminAdminsRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminApprovalsRoute: AdminApprovalsRoute,
  AdminBroadcastsRoute: AdminBroadcastsRoute,
  AdminCitiesRoute: AdminCitiesRoute,
  AdminCollegesRoute: AdminCollegesRoute,
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminCouponsRoute: AdminCouponsRoute,
  AdminEventsRoute: AdminEventsRoute,
  AdminGiftCardsRoute: AdminGiftCardsRoute,
  AdminIntegrationsRoute: AdminIntegrationsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

interface CollegesRouteChildren {
  CollegesCollegeSlugRoute: typeof CollegesCollegeSlugRoute
  CollegesIndexRoute: typeof CollegesIndexRoute
}

const CollegesRouteChildren: CollegesRouteChildren = {
  CollegesCollegeSlugRoute: CollegesCollegeSlugRoute,
  CollegesIndexRoute: CollegesIndexRoute,
}

const CollegesRouteWithChildren = CollegesRoute._addFileChildren(
  CollegesRouteChildren,
)

interface CompanyRouteChildren {
  CompanyAlertsRoute: typeof CompanyAlertsRoute
  CompanyBrandAssetsRoute: typeof CompanyBrandAssetsRoute
  CompanyMarketplaceRoute: typeof CompanyMarketplaceRoute
  CompanyMessagesRoute: typeof CompanyMessagesRoute
  CompanyProposalsRoute: typeof CompanyProposalsRoute
  CompanyScanRoute: typeof CompanyScanRoute
  CompanySettingsRoute: typeof CompanySettingsRoute
  CompanyWalletRoute: typeof CompanyWalletRoute
  CompanyIndexRoute: typeof CompanyIndexRoute
}

const CompanyRouteChildren: CompanyRouteChildren = {
  CompanyAlertsRoute: CompanyAlertsRoute,
  CompanyBrandAssetsRoute: CompanyBrandAssetsRoute,
  CompanyMarketplaceRoute: CompanyMarketplaceRoute,
  CompanyMessagesRoute: CompanyMessagesRoute,
  CompanyProposalsRoute: CompanyProposalsRoute,
  CompanyScanRoute: CompanyScanRoute,
  CompanySettingsRoute: CompanySettingsRoute,
  CompanyWalletRoute: CompanyWalletRoute,
  CompanyIndexRoute: CompanyIndexRoute,
}

const CompanyRouteWithChildren =
  CompanyRoute._addFileChildren(CompanyRouteChildren)

interface EventsRouteChildren {
  EventsEventIdRoute: typeof EventsEventIdRoute
  EventsIndexRoute: typeof EventsIndexRoute
}

const EventsRouteChildren: EventsRouteChildren = {
  EventsEventIdRoute: EventsEventIdRoute,
  EventsIndexRoute: EventsIndexRoute,
}

const EventsRouteWithChildren =
  EventsRoute._addFileChildren(EventsRouteChildren)

interface FestRouteChildren {
  FestSlugRoute: typeof FestSlugRoute
  FestIndexRoute: typeof FestIndexRoute
}

const FestRouteChildren: FestRouteChildren = {
  FestSlugRoute: FestSlugRoute,
  FestIndexRoute: FestIndexRoute,
}

const FestRouteWithChildren = FestRoute._addFileChildren(FestRouteChildren)

interface InviteRouteChildren {
  InviteAcceptRoute: typeof InviteAcceptRoute
}

const InviteRouteChildren: InviteRouteChildren = {
  InviteAcceptRoute: InviteAcceptRoute,
}

const InviteRouteWithChildren =
  InviteRoute._addFileChildren(InviteRouteChildren)

interface OrganizerEventsEventIdRouteChildren {
  OrganizerEventsEventIdEditRoute: typeof OrganizerEventsEventIdEditRoute
}

const OrganizerEventsEventIdRouteChildren: OrganizerEventsEventIdRouteChildren =
  {
    OrganizerEventsEventIdEditRoute: OrganizerEventsEventIdEditRoute,
  }

const OrganizerEventsEventIdRouteWithChildren =
  OrganizerEventsEventIdRoute._addFileChildren(
    OrganizerEventsEventIdRouteChildren,
  )

interface OrganizerRouteChildren {
  OrganizerActivityRoute: typeof OrganizerActivityRoute
  OrganizerAlertsRoute: typeof OrganizerAlertsRoute
  OrganizerMessagesRoute: typeof OrganizerMessagesRoute
  OrganizerNewRoute: typeof OrganizerNewRoute
  OrganizerScanRoute: typeof OrganizerScanRoute
  OrganizerSettingsRoute: typeof OrganizerSettingsRoute
  OrganizerSponsorAssetsRoute: typeof OrganizerSponsorAssetsRoute
  OrganizerTeamRoute: typeof OrganizerTeamRoute
  OrganizerWalletRoute: typeof OrganizerWalletRoute
  OrganizerIndexRoute: typeof OrganizerIndexRoute
  OrganizerEventsEventIdRoute: typeof OrganizerEventsEventIdRouteWithChildren
  OrganizerEventsIndexRoute: typeof OrganizerEventsIndexRoute
}

const OrganizerRouteChildren: OrganizerRouteChildren = {
  OrganizerActivityRoute: OrganizerActivityRoute,
  OrganizerAlertsRoute: OrganizerAlertsRoute,
  OrganizerMessagesRoute: OrganizerMessagesRoute,
  OrganizerNewRoute: OrganizerNewRoute,
  OrganizerScanRoute: OrganizerScanRoute,
  OrganizerSettingsRoute: OrganizerSettingsRoute,
  OrganizerSponsorAssetsRoute: OrganizerSponsorAssetsRoute,
  OrganizerTeamRoute: OrganizerTeamRoute,
  OrganizerWalletRoute: OrganizerWalletRoute,
  OrganizerIndexRoute: OrganizerIndexRoute,
  OrganizerEventsEventIdRoute: OrganizerEventsEventIdRouteWithChildren,
  OrganizerEventsIndexRoute: OrganizerEventsIndexRoute,
}

const OrganizerRouteWithChildren = OrganizerRoute._addFileChildren(
  OrganizerRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  StudentRoute: StudentRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AmbassadorsRoute: AmbassadorsRoute,
  BlogRoute: BlogRouteWithChildren,
  CollegesRoute: CollegesRouteWithChildren,
  CompanyRoute: CompanyRouteWithChildren,
  CookiePolicyRoute: CookiePolicyRoute,
  EventsRoute: EventsRouteWithChildren,
  FestRoute: FestRouteWithChildren,
  InviteRoute: InviteRouteWithChildren,
  LoginRoute: LoginRoute,
  OrganizerRoute: OrganizerRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  RefundRoute: RefundRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RobotsDottxtRoute: RobotsDottxtRoute,
  SignupRoute: SignupRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  SponsorsRoute: SponsorsRoute,
  TalentRoute: TalentRoute,
  TermsRoute: TermsRoute,
  SponsorDashboardRoute: SponsorDashboardRoute,
  SponsorPricingRoute: SponsorPricingRoute,
  SponsorScanRoute: SponsorScanRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
